export const isTokenUsable = (token) => {
  if (!token || typeof token !== 'string') {
    return false;
  }

  const parts = token.split('.');
  if (parts.length !== 3) {
    return false;
  }

  try {
    const payload = JSON.parse(atob(parts[1]));

    if (!payload?.exp) {
      return true;
    }

    return payload.exp * 1000 > Date.now();
  } catch (_error) {
    return false;
  }
};
